import {createBrowserRouter, Navigate, RouterProvider} from 'react-router-dom'
import {LoadingProvider} from './components/Loading'
import LoginPage from './pages/LoginPage'
import VssPage from './pages/VssPage'
import RegisterPage from './pages/RegisterPage'
import StatusPage from './pages/StatusPage'
import MainPage from "./pages/MainPage";


const router = createBrowserRouter([
  {
    path: '/',
    element: <MainPage/>,
  },
  {
    path: '/my-chiper',
    element: <VssPage/>,
  },
  {
    path: '/login',
    element: <LoginPage/>,
  },
  {
    path: '/*',
    element: <StatusPage code={404}/>,
  },
])

export default function App() {
  return <>
    <LoadingProvider>
      <RouterProvider router={router}/>
    </LoadingProvider>
  </>
};
